import all from "@myplay/all";
import { initializeSession, getMics } from "./opentok-api";
const { liveProduction } = all;
const { connectCommentator, startBroadcast, stopBroadcast } = liveProduction;
let publisher;

export const init = async (inviteToken, setVolumeLevel) => {
  try {
    const { sessionId, token, isBroadcasting } = await connectCommentator(
        inviteToken
    );
    publisher = initializeSession(sessionId, token, setVolumeLevel);
    return isBroadcasting;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const mute = () => {
  publisher.publishAudio(false);
};

export const unmute = () => {
  publisher.publishAudio(true);
};

export const startLiveBroadcast = async (inviteToken, setBroadcastState) => {
  try {
    await startBroadcast(inviteToken);
    setBroadcastState(false, true);
  } catch (e) {
    setBroadcastState(true, false);
  }
};

export const stopLiveBroadcast = async (inviteToken, setBroadcastState) => {
  try {
    await stopBroadcast(inviteToken);
    setBroadcastState(false);
  } catch (e) {}
};

export const getAvailableMics = async () => {
  return await getMics();
};

export const getPublisher = ()=> {
  return publisher;
};

export const setMainVolume = async (inviteToken, volume)=> {
    await liveProduction.setMainVolume(inviteToken,volume);
};

export const setCommentatorDelay = async (inviteToken, delay)=> {
  await liveProduction.setCommentatorDelay(inviteToken,delay);
};
